export default __webpack_public_path__ + "img/card-bulleted.ae79c075.svg";